import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AuthService } from '@core/services/auth.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { BcAdalAngularService } from 'bc-adal-angular';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public constants = new Constants();

  private loggedIn = new BehaviorSubject<boolean>(false);
  private accessDenied = new BehaviorSubject<boolean>(false);
  public accessDenied$ = this.accessDenied.asObservable();

  constructor(
    public appConfig: AppConfig,
    public authService: AuthService,
    public generalsService: GeneralsService,
    public adalService: BcAdalAngularService
  ) {}

  get isLoggedIn() {
    this.validateLogin();

    return this.loggedIn.asObservable();
  }

  logout() {
    this.loggedIn.next(false);
    this.generalsService.loading('mat-loading-logout');
    this.authService
      .logout()
      .pipe(
        takeUntil(this.constants.destroy$),
        catchError(() => of(false))
      )
      .subscribe(() => {
        this.adalService.logout();
      });
  }

  validateLogin() {
    if (window.location.hash.indexOf('error=access_denied') > 0) {
      this.accessDenied.next(true);
    }
    this.adalService.handleWindowCallback();
    const accessToken = this.adalService.accessToken,
      isAuthenticated = this.adalService.isAuthenticated;
    if (accessToken && isAuthenticated) {
      this.loggedIn.next(true);
      return true;
    }
    this.loggedIn.next(false);

    return false;
  }
}
